/* assets/swatch.js */
(function () {
  // --- tiny helpers ---
  const $  = (sel, el=document) => el.querySelector(sel);
  const $$ = (sel, el=document) => Array.from(el.querySelectorAll(sel));
  const normalize = (v) => String(v ?? '').trim().toLowerCase().replace(/\s+/g, ' ');
  const emit = (target, name, detail) => { try { target.dispatchEvent(new CustomEvent(name, { detail, bubbles: true })); } catch(_) {} };
  const storageKey = (pid) => `swatchState:${pid}`;

  // Money formatting (locale + Shopify fallback)
  const fmt = (cents) => {
    try {
      if (window.Shopify && typeof Shopify.formatMoney === 'function') {
        return Shopify.formatMoney(cents, (Shopify.money_format || (window.theme && theme.moneyFormat)));
      }
    } catch(_) {}
    const locale = document.documentElement.lang || 'de-DE';
    return new Intl.NumberFormat(locale, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
      .format((Number(cents) || 0) / 100);
  };

  // Fire a global event used by various themes/integrations
  function fireVariantChange(productId, variant){
    if (!productId || !variant) return;
    document.dispatchEvent(new CustomEvent('product:variant-change', {
      detail: { productId: String(productId), variant }
    }));
  }

  // Read state from checked radios (prefer raw value to survive translations)
  function readState(root){
    const groups = $$('.swatch[data-option-index]', root);
    const state = [];
    groups.forEach(g => {
      const i = Number(g.getAttribute('data-option-index'));
      const sel = $('.swatch__input:checked', g);
      if (sel) {
        const raw = sel.getAttribute('data-value-raw');
        state[i] = raw != null && raw !== '' ? raw : sel.value;
      } else {
        state[i] = null;
      }
    });
    return state;
  }

  // Variant matching tolerant to translated option labels
  function matchVariant(variants, state){
    if (!Array.isArray(variants) || !variants.length) return null;
    // strict, normalized equality
    let v = variants.find(x =>
      x.options && x.options.every((opt, i) => state[i] ? normalize(opt) === normalize(state[i]) : true)
    );
    if (!v) {
      // looser contains fallback
      const candidates = variants.filter(x =>
        x.options && x.options.every((opt, i) => state[i] ? normalize(opt).includes(normalize(state[i])) : true)
      );
      v = candidates.find(x => x.available) || candidates[0] || null;
    }
    if (!v) v = variants.find(x => x.available) || variants[0] || null;
    return v || null;
  }

  // Update hidden id input so theme/add-to-cart picks correct variant
  function updateId(form, variant){
    const idInput = $('input[name="id"]', form);
    console.log(variant);
    if (idInput && variant) {
      idInput.value = variant.id;
      idInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  // Robust price updater (works with currency/translation apps)
  function updatePrices(form, variant){
    if (!variant || !form) return;

    // 1) Regular/sale price nodes (cover common selectors)
    const priceNodes = [
      ...form.querySelectorAll(
        '.product-form__price-value, [data-product-price], [data-regular-price], ' +
        '.price__regular .price-item--regular, .price__sale .price-item--sale, ' +
        '.price .price-item--regular, .price .price-item--sale'
      )
    ];
    priceNodes.forEach(el => {
      el.textContent = fmt(variant.price);
      // attributes in CENTS that many apps read
      el.setAttribute('data-product-amount', String(variant.price));
      el.setAttribute('data-price', String(variant.price));
      if (variant.compare_at_price) {
        el.setAttribute('data-product-amount-compared', String(variant.compare_at_price));
      } else {
        el.removeAttribute('data-product-amount-compared');
      }
      el.setAttribute('data-dynamic-price', 'true');
    });

    // 2) Compare-at handling
    const showCompare = !!(variant.compare_at_price && variant.compare_at_price > variant.price);
    const compareNodes = [
      ...form.querySelectorAll(
        '.product-form__price-value--compared, [data-compare-price], .price__compare .price-item--regular, .price-item--compare'
      )
    ];
    compareNodes.forEach(n => {
      n.style.display = showCompare ? '' : 'none';
      if (showCompare) {
        n.textContent = fmt(variant.compare_at_price);
        n.setAttribute('data-compare-price', String(variant.compare_at_price));
      } else {
        n.removeAttribute('data-compare-price');
      }
    });

    // 3) Optional: save % (translation-friendly via data-i18n-template)
    const saveNode = form.querySelector('.save_percentage');
    if (saveNode) {
      if (showCompare) {
        const pct = Math.round(((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price);
        const tpl = saveNode.getAttribute('data-i18n-template') || '({{amount}}%)';
        saveNode.textContent = tpl.replace('{{amount}}', String(pct));
      } else {
        saveNode.textContent = '';
      }
    }

    // 4) Optional: custom discount UI
    const discountEl = form.querySelector('.discount-price');
    const badgeEl = form.querySelector('.custom-sale-span span');
    if (discountEl || badgeEl) {
      const rate = showCompare ? 0.10 : 0.15;
      const discounted = Math.round(variant.price * (1 - rate));
      if (discountEl) discountEl.textContent = fmt(discounted);
      if (badgeEl) {
        const badgeTpl = badgeEl.getAttribute('data-i18n-template'); // e.g. "{{amount}}% OFF"
        if (badgeTpl) {
          const pct = Math.round(rate * 100);
          badgeEl.textContent = badgeTpl.replace('{{amount}}', String(pct));
        } else {
          badgeEl.textContent = '';
        }
      }
    }

    // 5) Nudge converters/markets/translations
    const detail = { variant, form };
    emit(form, 'variant:price-change', detail);
    emit(document, 'variant:changed', detail);
    emit(document, 'product:variant-change', detail);
    try { document.dispatchEvent(new Event('currency:reload')); } catch(_) {}
    try { document.dispatchEvent(new Event('money:refresh')); } catch(_) {}
  }

  // Availability per option value based on current partial selection
  function updateAvailability(root, variants){
    const groups = $$('.swatch[data-option-index]', root);
    const state = readState(root);
    groups.forEach(group => {
      const idx = Number(group.getAttribute('data-option-index'));
      const filter = state.map((v, i) => i === idx ? null : v);
      const candidates = variants.filter(v =>
        v.options && v.options.every((opt, i) => filter[i] ? normalize(opt) === normalize(filter[i]) : true)
      );
      const byVal = new Map();
      candidates.forEach(v => {
        const val = v.options[idx];
        const key = normalize(val);
        if (!byVal.has(key)) byVal.set(key, []);
        byVal.get(key).push(v);
      });
      $$('.swatch__input', group).forEach(inp => {
        const raw = inp.getAttribute('data-value-raw') || inp.value;
        const key = normalize(raw);
        const list = byVal.get(key) || [];
        const available = list.some(v => v.available);
        inp.disabled = !available;
        const label = group.querySelector('label[for="'+inp.id+'"]');
        if (label) label.classList.toggle('is-disabled', !available);
      });
    });
  }

  function syncCheckedClasses(root){
    const groups = root.querySelectorAll('.swatch[data-option-index]');
    groups.forEach(group => {
      group.querySelectorAll('.swatch__btn').forEach(btn => btn.classList.remove('is-checked'));
      const sel = group.querySelector('.swatch__input:checked');
      if (sel) {
        const lbl = group.querySelector('label[for="' + sel.id + '"]');
        if (lbl) lbl.classList.add('is-checked');
      }
    });
  }


  // --- Persist / Restore swatch selection around Add-to-Cart ---
  function saveSwatchState(productId, variant){
    if (!productId || !variant) return;
    const payload = { vid: String(variant.id), options: Array.isArray(variant.options) ? variant.options : [] };
    try { localStorage.setItem(storageKey(productId), JSON.stringify(payload)); } catch(_) {}
  }
  function loadSwatchState(productId){
    try {
      const raw = localStorage.getItem(storageKey(productId));
      return raw ? JSON.parse(raw) : null;
    } catch(_) { return null; }
  }
  function restoreSwatchesByOptions(root, saved){
    if (!saved || !Array.isArray(saved.options)) return false;
    let changed = false;
    const groups = $$('.swatch[data-option-index]', root);
    cobseole.log(saved);
    groups.forEach(g => {
      const idx = Number(g.getAttribute('data-option-index'));
      const desired = saved.options[idx];
      if (desired == null) return;
      const want = normalize(desired);
      const inputs = $$('.swatch__input', g);
      const match = inputs.find(inp => normalize(inp.getAttribute('data-value-raw') || inp.value) === want);
      if (match && !match.checked && !match.disabled) {
        match.click(); // triggers your existing change flow
        changed = true;
      }
    });
    return changed;
  }
  

  /* Read current swatch selections from the DOM (prefers raw value for translations) */
  function getCurrentSwatchState(root){
    const state = [];
    root.querySelectorAll('.swatch[data-option-index]').forEach(group => {
      const idx = Number(group.getAttribute('data-option-index'));
      const sel = group.querySelector('.swatch__input:checked');
      if (sel) {
        const raw = sel.getAttribute('data-value-raw');
        state[idx] = raw != null && raw !== '' ? raw : sel.value;
      } else {
        state[idx] = null;
      }
    });
    return state;
  }

  /* 2) GET — retrieve previously saved state for a product */
  function getSwatchState(productId){
    try {
      const raw = localStorage.getItem(storageKey(productId));
      return raw ? JSON.parse(raw) : null;
    } catch(_) { return null; }
  }

  /* 3) TRIGGER CLICK — re-apply saved options by clicking matching inputs */
  function triggerSwatchClicks(root, saved){
    if (!root || !saved || !Array.isArray(saved.options)) return false;
    let didClick = false;

    root.querySelectorAll('.swatch[data-option-index]').forEach(group => {
      const idx = Number(group.getAttribute('data-option-index'));
      const want = saved.options[idx];
      if (want == null) return;

      const targetKey = normalize(want);
      const inputs = group.querySelectorAll('.swatch__input');

      const match = Array.from(inputs).find(inp => {
        const raw = inp.getAttribute('data-value-raw') || inp.value;
        return normalize(raw) === targetKey;
      });

      if (match && !match.checked && !match.disabled) {
        match.click();       // fires your existing change handlers
        didClick = true;
      }
    });

    return didClick;
  }


  // --- Init per swatch root ---
  function initRoot(root){
    let variants = [];
    try { variants = JSON.parse(root.getAttribute('data-variants') || '[]'); } catch(_) {}
    if (!variants.length) return;

    // product id (from root or nearby containers)
    const productId =
      root.getAttribute('data-product-id') ||
      root.closest('[data-productid]')?.getAttribute('data-productid') ||
      null;

    const form =  root.closest('#product_form_'+productId);
    if (!form) return;

    // initial variant (from hidden id or first available)
    const idInput = $('input[name="id"]', form);
    let current = null;
    if (!current) current = variants.find(v => v.available) || variants[0];

    console.log(idInput);

    if (idInput && idInput.value) {
      current = variants.find(v => String(v.id) === String(idInput.value)) || null;
    }
    // Try to restore previously saved selection (before rendering everything)
    const saved = productId ? loadSwatchState(productId) : null;
    
    updateAvailability(root, variants);
    if (current) {
      updateId(form, current);
      updatePrices(form, current);
      fireVariantChange(productId, current);
    }

    // Re-apply saved options by clicking matching swatches (fires handlers)

    // Handle swatch change
    root.addEventListener('change', (e) => {
      const input = e.target.closest('.swatch__input');
      if (!input) return;
      const state = readState(root);
      const v = matchVariant(variants, state);
      if (!v) return;
      updateId(form, v);
      updatePrices(form, v);
      updateAvailability(root, variants);
      fireVariantChange(productId, v);
      if (productId) saveSwatchState(productId, v); // persist on any change
      syncCheckedClasses(root);
    }, true);

    // If theme changes variant id programmatically
    if (idInput) {
      ['input','change'].forEach(ev => {
        idInput.addEventListener(ev, () => {
          const v = variants.find(x => String(x.id) === String(idInput.value));
          if (!v) return;
          updatePrices(form, v);
          updateAvailability(root, variants);
          fireVariantChange(productId, v);
          if (productId) saveSwatchState(productId, v);
        });
      });
    }

    
    if (saved) restoreSwatchesByOptions(root, saved);

    // Save right before/during Add-to-Cart
    const atcBtn = form.querySelector('[name="add"], button[type="submit"], [data-add-to-cart]');
    const saveNow = () => {
      const v = variants.find(x => String(x.id) === String(idInput?.value)) || current;
      if (productId && v) saveSwatchState(productId, v);
    };
    if (atcBtn) atcBtn.addEventListener('click', saveNow, { capture: true });
    form.addEventListener('submit', saveNow, { capture: true });

    // If your theme fires ajax add success events, persist as well
    document.addEventListener('cart:line-item-added', saveNow);
  }

  function boot(){
    $$('.swatch-root[data-variants]').forEach(initRoot);
  }
  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();
